<template>
  <div class="d-none" />
</template>
<script>
import Listable from '@/components/mixins/listable';

export default {
  name: 'CustomerOutreachsListableManager',
  mixins: [Listable],
  props: {
    searchTerm: {
      type: String,
      default: '',
    },
    kwargs: {
      type: Object,
      default: () => {},
    },

    // listable options
    source: {
      type: String,
      default: 'outreachs',
    },
    getter: {
      type: String,
      default: 'customerOutReachContacts',
    },
    mode: {
      type: String,
      default: 'loadMore',
    },
    pageSize: {
      type: Number,
      default: 15,
    },
    noMultiRequest: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    fetchRoute() {
      return 'outreachs/addCustomerOutreachContact';
    },
    loading() {
      return this.$store.state.outreachs.corcsLoading;
    },
  },
  watch: {
    kwargs: {
      immediate: true,
      handler(newVal) {
        this.queryParams = newVal;
      },
    },
    elements(newVal) {
      this.$emit('input', { count: this.count, items: newVal });
    },
    searchTerm: {
      immediate: true,
      handler(newVal) {
        this.search = newVal;
      },
    },
  },
};
</script>
